import { Add, ProfileAdd } from 'iconsax-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useOnClickOutside } from 'usehooks-ts';
import CreateGroup from '@/assets/images/icons/create-group.svg?react';
import ProfileAdd2 from '@/assets/images/icons/profile-add-multiple.svg?react';
import { useIsDesktop } from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function AppHeaderMenu({ className }: Props) {
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const detailRef = useRef<HTMLDetailsElement>(null);

  useOnClickOutside(detailRef, () => detailRef.current?.removeAttribute('open'));

  return (
    <details
      className={cn('dropdown dropdown-end', className)}
      ref={detailRef}>
      <summary
        tabIndex={0}
        role='button'
        className='btn btn-square btn-ghost mode-embedded:btn-sm mode-embedded:text-primary-content'>
        <Add className='size-6' />
      </summary>

      <ul className='menu dropdown-content z-50 w-full min-w-40 rounded-lg bg-neutral-0 shadow-lg'>
        <li className='w-full'>
          <Link
            to={ROUTES.CONTACT.REQUEST.$path()}
            className='flex w-full items-center gap-2'>
            <ProfileAdd className='size-5' />
            {t('conversation.list.menu.add-friend')}
          </Link>
        </li>
        {!isDesktop && (
          <li className='w-full'>
            <Link
              to={ROUTES.CONTACT.REQUEST.SCAN.$path()}
              className='flex w-full items-center gap-2'>
              <ProfileAdd2 className='size-5' />
              {t('conversation.list.menu.join-group')}
            </Link>
          </li>
        )}
        <li className='w-full'>
          <Link
            to={ROUTES.CONTACT.GROUPS.CREATE.$path()}
            state={ROUTES.CONTACT.GROUPS.CREATE.$buildState({ state: { step: 0 } })}
            className='flex w-full items-center gap-2'>
            <CreateGroup className='size-5' />
            {t('conversation.list.menu.create-group')}
          </Link>
        </li>
      </ul>
    </details>
  );
}
